import { useRequest } from 'ahooks'
import { Form, Modal } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { JQLEditContent } from '@/components/jql/jql-edit-content.component'
import { ResourceType } from '@/schemas'

import { Customer } from '../../customer.schema'
import { JiraColumnProps } from './customer-jql-table-config.component'

interface CustomerJQLEditProps {
  columns: JiraColumnProps[]
  selfId: string
  jql: string | null
  visible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
  onSuccess: (jql: string) => void
  customer: Customer
}

export const CustomerJQLEdit: React.FC<CustomerJQLEditProps> = ({
  columns,
  selfId,
  jql,
  visible,
  setVisible,
  onSuccess,
  customer,
}) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const { run, loading } = useRequest(
    (jql) => ({
      url: `/api/customer/patch/${selfId}`,
      method: 'patch',
      data: {
        jql,
      },
    }),
    {
      manual: true,
      onSuccess: (_, [jql]) => {
        onSuccess(jql)
        setVisible(false)
      },
    }
  )

  const onOk = () => {
    form.submit()
  }

  return (
    <Modal
      title={t('configure jql')}
      width='80vw'
      okText={t('save')}
      visible={visible}
      onOk={onOk}
      onCancel={() => setVisible(false)}
      okButtonProps={{ loading }}
    >
      <JQLEditContent
        columns={columns}
        form={form}
        jql={jql}
        onSubmit={run}
        entity={{ name: customer.name, type: ResourceType.CUSTOMER }}
      />
    </Modal>
  )
}
